import { createSelector, Selector } from 'reselect';

import { RootState } from '../../redux/root-reducer';

export const currentPageSelector: Selector<RootState, number> = createSelector(
    (state: RootState) => state.appConfigurator,
    page => page.currentPage,
);
